import styled from 'styled-components';

import { COLUMN_WIDTH } from '@src/styles/dimensions';
import { HStack, setAlpha } from '@talos/kyoko';

import { predictionLegSurfaceColor, predictionLegTextColor, type PredictionLeg } from './predictionLegColors';

/** Non-interactive Yes/No label using the prediction card's outcome button colors. */
export const PredictionLegTag = styled.span<{ $leg: PredictionLeg }>`
  display: inline-flex;
  align-items: center;
  border-radius: ${({ theme }) => theme.borderRadiusDefault}px;
  padding: 0 ${({ theme }) => theme.spacing4}px;
  font-size: ${({ theme }) => theme.fontSizeTiny}rem;
  font-weight: ${({ theme }) => theme.fontWeightMedium};
  line-height: ${({ theme }) => theme.fontSizeDefault}rem;
  color: ${({ $leg, theme }) => predictionLegTextColor($leg, theme)};
  background: ${({ $leg, theme }) => predictionLegSurfaceColor($leg, theme, 0.12)};
`;

export const PredictionMarketsWrapper = styled(HStack)`
  flex: 1 1 0;
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: ${({ theme }) => theme.backgroundBody};
`;

export const AddButton = styled.button.attrs(() => ({ type: 'button' }))`
  background: none;
  border: none;
  cursor: pointer;
  outline: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.gray['080']};
  padding: 50px;
  height: auto;
  border: 1px dashed ${({ theme }) => theme.colors.gray['070']};
  border-radius: ${({ theme }) => theme.borderRadiusDefault}px;
  transition: 250ms;

  svg {
    margin-bottom: ${({ theme }) => theme.spacing24}px;
    transition: 250ms;
  }

  &:hover {
    border-color: ${({ theme }) => theme.colors.gray['090']};
    padding: 53px;

    svg {
      transform: scale(1.1);
    }
  }
`;

export const Filler = styled.div`
  width: ${COLUMN_WIDTH}px;
`;

export const Column = styled.div`
  position: relative;
  max-width: ${({ theme }) => COLUMN_WIDTH + theme.spacing2}px;

  div {
    outline: none;
  }
`;

export const DragWrapper = styled.div`
  margin: ${({ theme }) => `0 ${theme.spacing2}px ${theme.spacing2}px 0`};
`;

export const DropZone = styled.div`
  position: relative;
  height: 100%;
`;

export const Cards = styled.div<{ isEmptyView: boolean }>`
  background: ${({ theme }) => setAlpha(0.6, theme.colors.gray['010'])};
  display: grid;
  flex: 1 1 0;
  ${({ isEmptyView, theme }) =>
    !isEmptyView &&
    `
    grid-template-columns: repeat(auto-fill, ${COLUMN_WIDTH + theme.spacing2}px);
    grid-auto-flow: column;
  `};
  height: 100%;
  overflow: auto;

  &::-webkit-scrollbar-corner {
    background: transparent;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  z-index: 1;
`;
